(function(app) {

    app.provider("appointmentDetailApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(appointmentDetailId) {
                            return crmApiGateway.get("/AppointmentDetails/" + appointmentDetailId);
                        }

                        service.getAppointmentDetails = function() {
                            return crmApiGateway.getArray("/AppointmentDetails");
                        }

                        service.update = function(appointmentDetailId, appointmentDetail) {
                            return crmApiGateway.put("/AppointmentDetails/" + appointmentDetailId, appointmentDetail);
                        }

                        service.create = function(appointmentDetail) {
                            return crmApiGateway.post("/AppointmentDetails", appointmentDetail);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line